import React from 'react';
import {Tooltip} from "@mui/material";
class URLCountCompClass extends React.Component{
    constructor(props) {
        super(props);
        this.state={}
    }// constructor
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.urlCount.length !== nextProps.urlCount.length
            || this.props.disabled !== nextProps.disabled
        );
    }

    render() {
        const { handleUrlCount, urlCount, disabled } = this.props;
        return(
            <>
                <Tooltip title={<div>
                    <p>메시지 내 포함될 URL을 입력해주세요. 입력한 URL을 기준으로 반응률이 측정됩니다.</p>
                </div>}>
                    <div className={"d-inline-flex align-items-center pointer me-2"}>
                        <h5 className='d-inline-block mb-1 fs-5'>URL 분석</h5>
                        <span className="material-symbols-rounded mb-2 fs-5 text-primary ms-1">info</span>
                    </div>
                </Tooltip>

                <div className="d-flex">
                    <div className="form-check pe-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name={`URL_COUNT`}
                            id={`URL_COUNT1`}
                            value={0}
                            onChange={handleUrlCount}
                            checked={urlCount.length === 0}
                            disabled={disabled}
                        />
                        <label className="form-check-label" htmlFor={`URL_COUNT1`}>
                            없음
                        </label>
                    </div>
                    <div className="form-check pe-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name={`URL_COUNT`}
                            id={`URL_COUNT2`}
                            value={1}
                            onChange={handleUrlCount}
                            checked={urlCount.length === 1}
                            disabled={disabled}
                        />
                        <label className="form-check-label" htmlFor={`URL_COUNT2`}>
                            1개
                        </label>
                    </div>
                    <div className="form-check pe-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name={`URL_COUNT`}
                            id={`URL_COUNT3`}
                            value={2}
                            onChange={handleUrlCount}
                            checked={urlCount.length === 2}
                            disabled={disabled}
                        />
                        <label className="form-check-label" htmlFor={`URL_COUNT3`}>
                            2개
                        </label>
                    </div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name={`URL_COUNT`}
                            id={`URL_COUNT4`}
                            value={3}
                            onChange={handleUrlCount}
                            checked={urlCount.length === 3}
                            disabled={disabled}
                        />
                        <label className="form-check-label" htmlFor={`URL_COUNT4`}>
                            3개
                        </label>
                    </div>
                </div>
            </>
        )
    }
}// end class

export default URLCountCompClass;
